import React, { memo } from "react";
import Skeleton from "@mui/material/Skeleton";
import { Card, CardHeader } from "components/ui";

const DefaultPreferencesSkeleton = memo(() => {
  return (
    <div className="flex grow gap-5 lg:gap-7.5 mb-5">
      <aside className="hidden lg:block w-[230px] shrink-0">
        <div className="sticky top-[150px] grid gap-3">
          {Array.from({ length: 8 }, (_, index) => (
            <Skeleton key={index} variant="text" width="80%" height={28} />
          ))}
        </div>
      </aside>

      <div className="grow min-w-0 grid gap-5 lg:gap-7.5">
        {Array.from({ length: 8 }, (_, index) => (
          <Card key={index} className="!pb-0">
            <CardHeader className="!border-b-0">
              <div className="flex w-full items-center justify-between">
                <Skeleton variant="text" width={150} height={32} />
                <Skeleton variant="circular" width={24} height={24} />
              </div>
            </CardHeader>
          </Card>
        ))}

        <div className="sticky bottom-0 z-10 flex items-center justify-between gap-3 rounded-lg border border-border bg-background px-5 py-3 shadow-sm">
          <Skeleton variant="text" width={160} height={24} />
          <Skeleton
            variant="rounded"
            width={96}
            height={40}
            sx={{ borderRadius: "6px" }}
          />
        </div>
      </div>
    </div>
  );
});

DefaultPreferencesSkeleton.displayName = "DefaultPreferencesSkeleton";

export default DefaultPreferencesSkeleton;
